// @flow
import React from "react";
import { Carousel } from "react-bootstrap";

const blueColor = {
  backgroundColor: "#39719a"
};

const greyColor = {
  backgroundColor: "#5d5e60"
};

const lightGreyColor = {
  backgroundColor: "#f5f5f5"
};

class SectionTestimonial extends React.Component {
  render() {
    const testimonials = [
      {
        message:
          "Great work was amazing working with the Window Outfitters they have went well beyond my expectations with my condo in Mississauga. Will for sure use them on my next project !",
        author: "Peter (Toronto)"
      },
      {
        message: "Best prices in the GTA they work for me on all my projects further in bowmanville and have always been on time! Punctuality has always been met and they have always valued my time.",
        author: "Ali"
      },
      {
        message: "Amazing shutters got them in 2 weeks just like I was told. Installation was clean and quick fit perfectly all custom made to the windows. Responsiveness is 5 star, great work Mayu.",
        author:
          "Irene"
      }
    ];

    // The paddingTop and paddingBottom are added because of collasping margin
    // See: https://medium.com/fed-or-dead/margin-collapse-or-why-your-child-element-is-moving-the-parent-b199a0b60497
    return (
      <div id="testimonial" style={{ minHeight: '50vh', color: "#f5f5f5", width: "100%", ...blueColor, paddingTop: '1px', paddingBottom: '1px' }}>
        <h1>Customer Testimonials</h1>
        {testimonials.map((testimonial, index) => {
          return (
            <div key={index+testimonial.author}>
                <h3>{testimonial.message}</h3>
                <p>{testimonial.author}</p>
                {(index < 2) ? <hr style={{ width: "80%", borderColor: "#5d5e60" }}/>: null}
            </div>
          );
        })}
      </div>
    );
  }
}

export default SectionTestimonial;



// WEBPACK FOOTER //
// ./src/pages/home/SectionTestimonial.js